<!-- 组件说明 -->
<template>
    <div class="commodityType">
        <el-dialog title="提示" :visible.sync="dialogVisible" width="704px">
            <!-- :options="indexOptions"  @expand-change="cascaderexpand" @change="cascaderChange" -->
            <!-- @expand-change="cascaderexpand" @change="cascaderChange" :props="indexProps"  -->
            <div class="optionsView">
                <ul>
                    <li
                        v-for="(val, inx) of indexOptions1"
                        :key="inx"
                        :class="rootId == val.value ? 'selectLi' : ''"
                        @click="optionsFun($event, val, 1)"
                    >
                        <span>{{ val.label }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
                <ul>
                    <li
                        v-for="(val, inx) of indexOptions2"
                        :key="inx"
                        :class="leafId == val.value ? 'selectLi' : ''"
                        @click="optionsFun($event, val, 2)"
                    >
                        <span>{{ val.label }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
                <ul>
                    <li
                        v-for="(val, inx) of indexOptions3"
                        :key="inx"
                        :class="sonId == val.value ? 'selectLi' : ''"
                        @click="optionsFun($event, val, 3)"
                    >
                        <span>{{ val.label }}</span>
                        <!-- <i class="el-icon-arrow-right"></i> -->
                    </li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="isConfirm" @click="panelConfirm">确 定</el-button>
                <el-button @click="expandChange">测试</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
    name: 'CommodityType',
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        // supplier: {
        //   type: Array,
        //   default() {
        //     return [];
        //   },
        // },
        // expandChange: {
        //   type: Function,
        //   default() {
        //     return;
        //   }
        // },
        // change: {
        //   type: Function,
        //   default() {
        //     return;
        //   }
        // }
    },
    data() {
        return {
            dialogVisible: false,
            indexOptions: [],
            isConfirm: false,
            options: [],
            indexOptions1: [], // 第一列
            indexOptions2: [], // 第二列
            indexOptions3: [], // 第三列
            rootId: '', // 根id
            leafId: '', // 叶id
            sonId: '', // 子id
        };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        const that = this;
        this.$ajax
            .get('/api/kuaishou/category/search')
            .then(function (res) {
                if (res.code == 200) {
                    const str = JSON.stringify(res.result)
                        .replace(/categoryId/g, 'value')
                        .replace(/categoryName/g, 'label');
                    localStorage.setItem('categorySearch', str);
                    that.options = JSON.parse(str);
                    const data = JSON.parse(str);
                    const list1 = data.filter((v) => {
                        return v.categoryPid == 0;
                    });
                    list1.map((v) => {
                        if (!v['children']) {
                            v['children'] = data.filter((val) => {
                                return v.value == val.categoryPid;
                            });
                        }
                        return v;
                    });
                    list1.map((v) => {
                        return v['children'].map((val) => {
                            if (!val['children']) {
                                val['children'] = data.filter((value) => {
                                    return val.value == value.categoryPid;
                                });
                            }
                            return val;
                        });
                    });
                    // options.indexOptions = list1
                    that.indexOptions = list1;
                }
            })
            .then(function () {
                const list = that.options.filter(function (v) {
                    return v.categoryPid == 0;
                });
                that.indexOptions1 = list;
            })
            .catch(function () {});
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    methods: {
        panelConfirm() {},
        optionsFun(t, val, inx) {
            // t:点击本身 val:点击的本身内容 inx
            const that = this;
            if (inx == 1) {
                that.rootId = val.value;
                const list = that.options.filter(function (v) {
                    return v.categoryPid == val.value;
                });
                that.indexOptions2 = list;
                that.indexOptions3 = [];
            } else if (inx == 2) {
                that.leafId = val.value;
                const list = that.options.filter(function (v) {
                    return v.categoryPid == val.value;
                });
                that.indexOptions3 = list;
            } else {
                const data = [];
                that.sonId = val.value;
                data.push(that.rootId);
                data.push(that.leafId);
                data.push(that.sonId);

                that.$emit('expand-change', data);
            }
        },
        expandChange() {
            this.$emit('expand-change');
        },
    },
};
</script>

<style lang="scss" scoped>
.optionsView {
    //   border: 1px solid #dddddd;
    display: flex;
    border: 1px solid #dddddd;
    height: 324px;
    ul {
        width: 33.33%;
        overflow: auto;
        li {
            padding: 10px 12px 10px 16px;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
        }
    }
    ul:nth-child(even) {
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
    }
}
.selectLi {
    background: #388eef;
    color: #ffffff;
}
//@import url()
</style>
